import React from "react";
import { Space, Typography } from "antd";

const { Text } = Typography;

interface TabLabelProps {
  count: number;
  label: string;
  color: string;
}

const TabLabel: React.FC<TabLabelProps> = ({ count, label, color }) => (
  <Space size={8} className="px-3 py-2">
    <div className="w-2 h-2 rounded-full" style={{ backgroundColor: color }} />
    <Text style={{ fontSize: 20,
      fontWeight: "700" }}>{label}</Text>
    <Text className="text-gray-500" style={{ color: "grey" }}>
      ({count})
    </Text>
  </Space>
);

export default TabLabel;
